import styled from "@emotion/styled";
import { makeStyles } from "@material-ui/core/styles";

export const HostContainer = styled.div`
  width: 100%;
`;

export const useFlyerCreatePageHeaderStyles = makeStyles(() => ({
  addButton: {
    color: "#1E8549",
    "&:not(.Mui-disabled)": {
      borderColor: "#1E8549 !important",
    },
  },
}));
